import axios from 'axios'
import {serialize} from '../../../core/_util'
import {GET_FILE_URL} from '../../investor-database/core/_requests'
const API_URL = process.env.REACT_APP_BASE_API_URL

export const GET_COLUMN_LIST = `${API_URL}/column/list`
const ADD_CUSTOM_FIELD = `${API_URL}/investor/custom-field`
const GET_CUSTOM_FIELD = `${API_URL}/investor/custom-field`
const UPDATE_CUSTOM_FIELD = `${API_URL}/investor/update-custom-field`
const DELETE_CUSTOM_FIELD = `${API_URL}/investor/delete-custom-field`
const UPDATE_INDEX = `${API_URL}/columns/position`
const GET_ALL_INVESTOR_USERS = `${API_URL}/investor-user/investor`
const GET_INVESTOR_RESPONSE = `${API_URL}/investor/investor-response`
const CREATE_INVESTOR_CSV = `${API_URL}/investor/csv/import`
const GET_INVESTOR_FOR_ROUND = `${API_URL}/investor/round`

export const getColumnList = (id: number) => {
  return axios.get(`${GET_COLUMN_LIST}/${id}`, {
    validateStatus(status) {
      return true
    },
  })
}

export const getActiveRound = (companyId: number) => {
  return axios.get(`${API_URL}/round/active/${companyId}`, {
    validateStatus(status) {
      return true
    },
  })
}

export const getAllRounds = (companyId: number) => {
  return axios.get(`${API_URL}/round/list/${companyId}`, {
    validateStatus(status) {
      return true
    },
  })
}
export const getRoundById = (roundId: number) => {
  return axios.get(`${API_URL}/round/${roundId}`, {
    validateStatus(status) {
      return true
    },
  })
}

export const deleteRoundById = (roundId: number) => {
  return axios.delete(`${API_URL}/round/${roundId}`, {
    validateStatus(status) {
      return true
    },
  })
}

//newAPIforabove
export const getAllColumnsFromRoundIdIU = (
  roundId: number,
  search?: string,
  sort_by_investor?: string,
  sort_order_investor?: string
) => {
  const object = {
    searchfilter: search,
    sort_by: sort_by_investor,
    sort_order: sort_order_investor,
  }
  return axios.get(`${API_URL}/column/investoruser-list/${roundId}?${serialize(object)}`, {
    validateStatus(status) {
      return true
    },
  })
}

export const updateColumnFromApi = ({columnId, investorId, investorUserId, roundId}: any) => {
  return axios.put(
    `${API_URL}/investor-column`,
    {
      columnId,
      investorId,
      investorUserId,
      roundId,
    },
    {
      validateStatus(status) {
        return true
      },
    }
  )
}

export const addColumn = ({
  columnName,
  color,
  roundId,
}: {
  columnName: string
  color: string
  roundId: number
}) => {
  return axios.post(
    `${API_URL}/column`,
    {
      columnName,
      color,
      roundId,
    },
    {
      validateStatus(status) {
        return true
      },
    }
  )
}

export const editColumn = ({
  columnName,
  color,
  columnId,
}: {
  columnName: string
  color: string
  columnId: number
}) => {
  return axios.put(
    `${API_URL}/column/${columnId}`,
    {
      columnName,
      color,
    },
    {
      validateStatus(status) {
        return true
      },
    }
  )
}

export const deleteColumn = (columnId: number) => {
  return axios.delete(`${API_URL}/column/${columnId}`, {
    validateStatus(status) {
      return true
    },
  })
}

export const getInvestorApi = (companyId: number, type?: string) => {
  return axios.get(`${API_URL}/company/investor/${companyId}?type=${type ? type : ''}`, {
    validateStatus(status) {
      return true
    },
  })
}

export const createTransactionApi = (values: any) => {
  return axios.post(`${API_URL}/investment/confirm`, values, {
    validateStatus(status) {
      return true
    },
  })
}

export const rejectTransactionApi = (values: any) => {
  return axios.post(`${API_URL}/investment/reject`, values, {
    validateStatus(status) {
      return true
    },
  })
}
export const createActivity = (values: any) => {
  return axios.post(`${API_URL}/activity`, values, {
    validateStatus(status) {
      return true
    },
  })
}

export const getAllActivities = (
  companyId: number,
  investorId: number,
  type: string,
  activitySearch: string,
  filterActivity: string | undefined,
  sort_by_activity: string | undefined,
  sort_order_activty: string | undefined,
  limit?: number
) => {
  const object = {
    search: activitySearch,
    sort_by: sort_by_activity,
    sort_order: sort_order_activty,
    limit: limit,
  }
  let queryString = serialize(object)
  if (filterActivity && filterActivity.length > 0) {
    if (queryString.length > 0) {
      queryString = `${queryString}&${filterActivity}`
    } else {
      queryString = `${filterActivity}`
    }
  }

  return axios.get(`${API_URL}/activity/${companyId}/${investorId}?type=${type}&${queryString}`, {
    validateStatus(status) {
      return true
    },
  })
}

export const editActivity = (values: any) => {
  return axios.put(`${API_URL}/activity`, values, {
    validateStatus(status) {
      return true
    },
  })
}
export const deleteActivity = (activityId: number) => {
  return axios.delete(`${API_URL}/activity/delete/${activityId}`, {
    validateStatus(status) {
      return true
    },
  })
}
export const exportAcivity = (values: any) => {
  return axios.post(`${API_URL}/activity/csv/export`, values, {
    validateStatus(status) {
      return true
    },
  })
}

export const exportAllInvestorUsers = (values: any) => {
  return axios.post(`${API_URL}/investor/csv/export`, values, {
    validateStatus(status) {
      return true
    },
  })
}

export const getAllUsers = (companyId: number) => {
  return axios.get(`${API_URL}/user/${companyId}`, {
    validateStatus(status) {
      return true
    },
  })
}

export const addCustomField = (data: any) => {
  return axios.post(ADD_CUSTOM_FIELD, data, {
    validateStatus(status) {
      return true
    },
  })
}

export const getCustomField = (investorId: number, roundId: number) => {
  return axios.get(`${GET_CUSTOM_FIELD}/${investorId}/${roundId}`, {
    validateStatus(status) {
      return true
    },
  })
}

export const updateCustomField = (customId: number, data: any) => {
  return axios.put(`${UPDATE_CUSTOM_FIELD}/${customId}`, data, {
    validateStatus(status) {
      return true
    },
  })
}

export const deleteCustomField = (id: number) => {
  return axios.delete(`${DELETE_CUSTOM_FIELD}/${id}`, {
    validateStatus(status) {
      return true
    },
  })
}

export const updateActiveRoundInCompany = (data: any) => {
  return axios.put(`${API_URL}/company/active-round`, data, {
    validateStatus(status) {
      return true
    },
  })
}

export const updateColumnIndex = (columns: any, roundId: number) => {
  return axios.put(
    `${UPDATE_INDEX}/${roundId}`,
    {columns},
    {
      validateStatus(status) {
        return true
      },
    }
  )
}
//This will delete InvestorUser from the Column.
export const deleteInvestorColumn = (obj: {
  investorId: number
  investorUserId: number
  columnId: number
}) => {
  return axios.delete(
    `${API_URL}/investoruser-column/${obj.investorId}/${obj.investorUserId}/${obj.columnId}`,
    {
      validateStatus(status) {
        return true
      },
    }
  )
}

export const getAllInvestorUsers = (investorId: number, roundId: number) => {
  return axios.get(`${GET_ALL_INVESTOR_USERS}/${investorId}/${roundId}`, {
    validateStatus(status) {
      return true
    },
  })
}

export const getInvestorResponseAPI = (
  investorId: number,
  investorUserId: number,
  roundId: number
) => {
  return axios.get(`${GET_INVESTOR_RESPONSE}/${investorId}/${investorUserId}/${roundId}`, {
    validateStatus(status) {
      return true
    },
  })
}

export const downloadFileSigned = (activiyName: string) => {
  const file = encodeURIComponent(activiyName)
  return axios.get(`${GET_FILE_URL}/signed/${file}`, {
    validateStatus(status) {
      return true
    },
  })
}

export const createInvestorCSV = (data: any, companyId: number) => {
  return axios.post(
    `${CREATE_INVESTOR_CSV}`,
    {...data, companyId: companyId},
    {
      validateStatus(status) {
        return true
      },
    }
  )
}

export const getInvestorsforRound = (
  searchValue: string | undefined,
  roundId: number | undefined,
  page?: number,
  size?: number
) => {
  const queryParams = {
    ...(searchValue && {name: searchValue}),
    ...(page !== undefined && {page}), // Checking against undefined since page can be 0.
    ...(size !== undefined && {size}), // Similarly for size.
  }
  return axios.get(`${GET_INVESTOR_FOR_ROUND}/${roundId}?${serialize(queryParams)}`, {
    validateStatus() {
      return true
    },
  })
}

export const getAllCompany = (data_limit: number, searchfilter?: string, isMyCompany?: boolean) => {
  const object = {
    search: searchfilter,
    limit: data_limit,
    isMyCompany,
  }
  return axios.get(`${API_URL}/companies?${serialize(object)}`, {
    validateStatus(status) {
      return true
    },
  })
}
